<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <history-player></history-player>
    <consentimiento
      :spiner="spinerAcepto"
      @aceptar="updateAcepta"
    ></consentimiento>
    <pendiente
      :listPendientes="listSancionesPopup"
      @recargaPopPendientes="
        getSancionesPopup()
        getSanciones()
      "
    ></pendiente>
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->

    <!-- <dark-Toggler class="d-none d-lg-block" /> -->
    <!-- <locale class="d-none d-lg-block" /> -->
    <b-nav-item-dropdown id="dropdown-grouped" right class="d-none d-lg-block">
      <template #button-content>
        <b-img :src="torneoActual.imagen" height="18px" width="18px" />
        <span class="ml-50 text-body font-weight-bold text-uppercase">{{
          torneoActual.torneo
        }}</span>
      </template>
      <b-dropdown-item
        v-for="item in listTorneos"
        :key="item.id_torneo"
        @click="changeTorneo(item)"
      >
        <b-img :src="item.imagen" height="18px" width="18px" />
        <span class="ml-50">{{ item.torneo }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        class="dropdown-notification mr-25"
        menu-class="dropdown-menu-media"
        right
      >
        <template #button-content>
          <feather-icon
            badge-classes="bg-danger"
            class="text-body"
            icon="SearchIcon"
            size="21"
            @click="showModalHistorial"
          />
        </template>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        v-if="
          (USER().rol === `${ROLES.ADMIN}` ||
            USER().rol === `${ROLES.CALIFICACION}` ||
            USER().rol === `${ROLES.SUPER}`) &&
            listRevision.length != 0
        "
        class="dropdown-notification mr-25"
        menu-class="dropdown-menu-media"
        right
      >
        <template #button-content>
          <feather-icon
            :badge="listRevision.length"
            badge-classes="bg-danger"
            class="text-body"
            icon="BellIcon"
            size="21"
          />
        </template>

        <!-- Header -->
        <li class="dropdown-menu-header">
          <div class="dropdown-header d-flex">
            <h4 class="notification-title mb-0 mr-auto">
              Solicitudes Revisión
            </h4>
            <b-badge pill variant="light-primary">
              {{ listRevision.length }} New
            </b-badge>
          </div>
        </li>
        <b-list-group style="max-height:60vh; overflow:scroll">
          <b-list-group-item
            style="cursor:pointer"
            @click="activateRevision(item)"
            v-for="item in listRevision"
            :key="item.id"
            ><span class="font-weight-bolder text-capitalize">
              {{ item.apodo }} {{ item.alias_equipo }}
            </span>
            <small class="notification-text">
              {{ item.disciplina }}
              {{ item.categoria }}
            </small></b-list-group-item
          >
        </b-list-group>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        v-if="
          (USER().rol === `${ROLES.ADMIN}` ||
            USER().rol === `${ROLES.SANCIONES}` ||
            USER().rol === `${ROLES.SUPER}`) &&
            listSanciones.length != 0
        "
        class="dropdown-notification mr-25"
        menu-class="dropdown-menu-media"
        right
      >
        <template #button-content>
          <feather-icon
            :badge="listSanciones.length"
            badge-classes="bg-danger"
            class="text-body"
            icon="SmartphoneIcon"
            size="21"
          />
        </template>

        <!-- Header -->
        <li class="dropdown-menu-header">
          <div class="dropdown-header d-flex">
            <h4 class="notification-title mb-0 mr-auto">
              Sanciones pendientes
            </h4>
            <b-badge pill variant="light-primary">
              {{ listSanciones.length }} New
            </b-badge>
          </div>
        </li>
        <b-list-group style="max-height:60vh; overflow:scroll">
          <b-list-group-item
            style="cursor:pointer"
            v-for="item in listSanciones"
            :key="item.id"
          >
            <item-sancion :item="item" @sancionExito="quitarDeLista($event)">
            </item-sancion>
          </b-list-group-item>
        </b-list-group>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p
              class="user-name font-weight-bolder mb-0"
              style="text-transform:capitalize"
            >
              {{ NameUser }}
            </p>
            <span class="user-status">{{ rolName }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="foto"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!-- <b-dropdown-item @click="prueba" link-class="d-flex align-items-center">
          <b-media>
            <template #aside>
              <b-avatar size="32" variant="success">
                <feather-icon icon="MailIcon" />
              </b-avatar>
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                Ajax a
              </span>
            </p>
            <small class="notification-text">baloncesto maxima</small>
          </b-media>
        </b-dropdown-item> -->

        <!-- <b-dropdown-item
          v-for="item in listRevision"
          :key="item.id"
          link-class="d-flex align-items-center"
        >
          <feather-icon size="16" icon="MailIcon" class="mr-50" />
          <span>{{ item.apodo }}</span>
        </b-dropdown-item> -->
        <!-- <b-list-group>
          <b-list-group-item v-for="item in listRevision" :key="item.id"
            >Cras justo odio</b-list-group-item
          >
        </b-list-group> -->

        <b-dropdown-item
          link-class="d-flex align-items-center"
          :to="{ name: 'profile' }"
        >
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>Mi Perfil</span>
        </b-dropdown-item>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
          <span>Chatss</span>
        </b-dropdown-item> -->

        <!-- <b-dropdown-divider /> -->

        <b-dropdown-item
          link-class="d-flex align-items-center"
          :to="{ name: 'login' }"
        >
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Salir</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  // BDropdownDivider,
  BAvatar,
  BBadge,
  // BMedia,
  BListGroup,
  BListGroupItem,
  BImg,
  // BFormCheckbox,
  // BButton,
  // BSpinner,
} from 'bootstrap-vue'
// import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
// import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import {
  onMounted,
  ref,
  onBeforeMount,
  watch,
  computed,
  // xx,
} from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
// import useNav from './useNav'
import {
  URL,
  USER,
  ROLES,
  STORAGE_NAME,
  VERSION,
  // xxx,
  // xx,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'
import ItemSancion from './ItemSancion.vue'
import HistoryPlayer from './HistoryPlayer.vue'
import Pendiente from './PendienteModal.vue'
import Consentimiento from './Consentimiento.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    // BDropdownDivider,
    BAvatar,
    BBadge,
    // VuePerfectScrollbar,
    // BButton,
    // Navbar Components
    // DarkToggler,
    // Locale,
    // BMedia,
    BListGroup,
    BListGroupItem,
    // BSpinner,
    ItemSancion,
    BImg,
    HistoryPlayer,
    Pendiente,
    Consentimiento,
    // BFormCheckbox,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  directives: {
    Ripple,
  },
  setup() {
    const NameUser = ref('')
    const rolName = ref('')
    const listRevision = ref([])
    const listSanciones = ref([])
    const listSancionesPopup = ref([])
    const listTorneos = ref([])
    const torneoActual = ref(USER().torneos[0])
    const foto = ref()
    const spinerAcepto = ref(false)
    // const showLoading = ref(false)
    const { getApi, postApi } = apiCall()
    const modoRevision = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getActivateRevision'],
    )
    const modoSancionPendiente = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getSancionPendiente'],
    )
    const updatePerfil = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getUpdatePerfil'],
    )
    // const foto = computed(
    //   // eslint-disable-next-line
    //   () => {
    //     console.log('aquiii')
    //     return USER().foto
    //     // eslint-disable-next-line
    //   }
    // )

    // const torneoActual = computed(
    //   // eslint-disable-next-line
    //   () => store.getters['someVariables/getTorneoSeleccionado']
    // )
    // console.log(torneoActual)
    // function holas() {
    //   console.log(this.$route.name)
    //   const rutaActual = this.$route.name
    //   if (rutaActual !== 'inscriptions') {
    //     router.push('inscriptions')
    //   }
    //   console.log('holassss')
    // }
    function showModalHistorial() {
      store.commit('someVariables/UPDATE_SHOW_HISTORIAL_PLAYER', true)
    }
    function showModalPendiente() {
      store.commit('someVariables/UPDATE_SHOW_PENDIENTES', true)
    }
    function showModalConsentimiento() {
      if (!USER().acepta_terminos) {
        store.commit('someVariables/UPDATE_SHOW_CONSENTIMIENTO', true)
      }
    }
    async function getSolicitudes() {
      listRevision.value = []
      const path = `ApiConfiguration/getSolicitudesRevision/${torneoActual.value.id_torneo}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        listRevision.value = data.data
      } else {
        listRevision.value = []
      }
    }
    function changeTorneo(item) {
      store.commit(
        'someVariables/UPDATE_TORNEO_SELECCIONADO',
        // eslint-disable-next-line
        item,
      )
      // console.log('cambio')
      torneoActual.value = item
      getSolicitudes()
    }
    function quitarDeLista(item) {
      const indice = listSanciones.value.findIndex(
        // eslint-disable-next-line
        element => element.id_sancion_pendiente === item.id_sancion_pendiente,
      )
      listSanciones.value.splice(indice, 1)
      // console.log(indice)
    }
    async function updateSancionPendiente(item) {
      // console.log(USER())
      // showLoading.value = true
      item.showLoading = true
      const dataSancion = {
        idEquipo: item.idEquipo,
        duracion: item.duracion,
        etapaBuscar: item.etapa_buscar,
        idSancion: item.id_sancion,
        idSancionPendiente: item.id_sancion_pendiente,
        idUser: USER().id_usuario,
      }
      const path = 'ApiSanciones/updateSancionPendiente'
      await postApi(URL, path, dataSancion)
      // console.log(data.data)
    }
    async function updateAcepta() {
      // console.log(USER())
      // showLoading.value = true
      spinerAcepto.value = true
      const dataSancion = {
        idUser: USER().id_usuario,
      }
      const path = 'ApiLogin/updateAceptaTerminos'
      await postApi(URL, path, dataSancion)
      spinerAcepto.value = false
      store.commit('someVariables/UPDATE_SHOW_CONSENTIMIENTO', false)
      const user = USER()
      user.acepta_terminos = true
      localStorage.setItem(STORAGE_NAME, JSON.stringify(user))
    }
    function defineNameByRol(rol) {
      const separaNombre = USER().nombre.split(' ')
      const separaApellido = USER().apellido.split(' ')
      NameUser.value = `${separaNombre[0]} ${separaApellido[0]}`
      if (rol === ROLES.CLUB) {
        rolName.value = USER().institucion
      } else {
        rolName.value = USER().rol
      }
    }

    async function getSanciones() {
      listSanciones.value = []
      const path = `ApiSanciones/getSancionesPendientes/${torneoActual.value.id_torneo}/1`
      const data = await getApi(URL, path)
      listSanciones.value = data.data
      listSanciones.value.forEach(element => {
        element.showLoading = false
      })
      // console.log(listSanciones.value)
    }
    async function getSancionesPopup() {
      listSancionesPopup.value = []
      const path = `ApiConfiguration/getCategoriasModalidadPopUp/${torneoActual.value.id_torneo}`
      const data = await getApi(URL, path)
      listSancionesPopup.value = data.data
      if (data.total_pendientes > 0) {
        showModalPendiente()
      }
      // listSancionesPopup.value.forEach(element => {
      //   element.showLoading = false
      // })
      // console.log(listSanciones.value)
    }
    async function getTorneos() {
      listTorneos.value = USER().torneos
      // console.log(USER())
    }
    function cargaSolicitudesRol(rol) {
      if (
        rol === ROLES.SUPER ||
        rol === ROLES.ADMIN ||
        rol === ROLES.CALIFICACION
      ) {
        getSolicitudes()
      }
    }
    function cargaSancionesPendienteRol(rol) {
      if (
        rol === ROLES.SUPER ||
        rol === ROLES.ADMIN ||
        rol === ROLES.SANCIONES
      ) {
        getSanciones()
        getSancionesPopup()
      }
    }
    watch(updatePerfil, () => {
      foto.value = USER()?.foto || ''
    })
    watch(modoRevision, data => {
      // console.log(data)
      if (!data) {
        cargaSolicitudesRol(USER().rol)
      }
    })
    watch(modoSancionPendiente, data => {
      // console.log(modoSancionPendiente)
      // console.log(data)
      if (data) {
        cargaSancionesPendienteRol(USER().rol)
      }
    })
    onBeforeMount(() => {
      // console.log('before', USER())
      cargaSolicitudesRol(USER().rol)
      cargaSancionesPendienteRol(USER().rol)
      getTorneos()
      showModalConsentimiento()
      store.commit(
        'someVariables/UPDATE_TORNEO_SELECCIONADO',
        // eslint-disable-next-line
        USER().torneos[0],
      )
    })
    function verificarVersion() {
      if (USER().app_version !== VERSION) {
        localStorage.removeItem(STORAGE_NAME)

        // opcional: limpiar todo
        // localStorage.clear()

        // mandar a login
        window.location.href = '/login'
      }
    }
    onMounted(() => {
      // console.log('em navbar')
      // console.log(USER())
      verificarVersion()
      defineNameByRol(USER().rol)
      foto.value = USER().foto
    })
    function activateRevision(item) {
      // console.log(item)
      const rutaActual = this.$route.name
      // console.log(rutaActual)
      if (rutaActual !== 'inscriptions') {
        router.push('inscriptions')
        setTimeout(() => {
          store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', item)
          store.commit('someVariables/UPDATE_ACTIVATE_REVISION', true)
        }, 1000)
      } else {
        store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', item)
        store.commit('someVariables/UPDATE_ACTIVATE_REVISION', true)
      }
    }
    // function activateSancionPendiente() {
    //   const rutaActual = this.$route.name
    //   console.log(rutaActual)
    //   if (rutaActual !== 'sanciones') {
    //     router.push('sanciones')
    //     setTimeout(() => {
    //       // store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', item)
    //       store.commit('someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE', true)
    //     }, 1000)
    //   } else {
    //     // store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', item)
    //     store.commit('someVariables/UPDATE_ACTIVATE_SANCION_PENDIENTE', true)
    //   }
    // }

    /* eslint-disable global-require */
    // const notifications = [
    //   {
    //     title: 'Congratulation Sam 🎉',
    //     avatar: require('@/assets/images/avatars/6-small.png'),
    //     subtitle: 'Won the monthly best seller badge',
    //     type: 'light-success',
    //   },
    //   {
    //     title: 'New message received',
    //     avatar: require('@/assets/images/avatars/9-small.png'),
    //     subtitle: 'You have 10 unread messages',
    //     type: 'light-info',
    //   },
    //   {
    //     title: 'Revised Order 👋',
    //     avatar: 'MD',
    //     subtitle: 'MD Inc. order updated',
    //     type: 'light-danger',
    //   },
    // ]
    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon',
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon',
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon',
      },
    ]
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }
    return {
      perfectScrollbarSettings,
      // notifications,
      systemNotifications,
      USER,
      NameUser,
      rolName,
      ROLES,
      activateRevision,
      listRevision,
      listSanciones,
      // activateSancionPendiente,
      updateSancionPendiente,
      // cargaSancionesPendienteRol,
      quitarDeLista,
      listTorneos,
      torneoActual,
      changeTorneo,
      foto,
      showModalHistorial,
      listSancionesPopup,
      getSancionesPopup,
      getSanciones,
      updateAcepta,
      spinerAcepto,
      // showLoading,
      // holas,
      // change,
      // saludoNav,
    }
  },
}
</script>
